import { type } from 'arktype';

import { CountryType } from '@/types/country';
import { FiatAccountType } from '@/types/fiatAccountType';

export enum NewContactType {
  internal = 'internal',
  external = 'external',
  unset = 'unset',
}

export const addContactFlowModalSchema = type({
  contactType: type.valueOf(NewContactType),
  country: type
    .valueOf(CountryType)
    .filter((c: CountryType): boolean => c !== CountryType.unset)
    .configure({ message: 'VALIDATION_REQUIRED' })
    .as<CountryType>(),
  paymentMethod: type
    .valueOf(FiatAccountType)
    .filter((f: FiatAccountType): boolean => f !== FiatAccountType.unset)
    .configure({ message: 'VALIDATION_REQUIRED' })
    .as<FiatAccountType>(),
});
